import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { firestore } from "../../services/firebase/index";

const FREQUENCY_KEY_BY_ID = {
    1: "monthly",
    2: "quarterly",
    3: "semiannual",
    4: "yearly",
};

const fetchLegacyProducts = async () => {
    const q = query(
        collection(firestore, "products"),
        // Inclui IAP (compras In-App da Apple Store / Google Play) para resolver o NOME
        // do produto (na tabela e no CSV) em vez de exibir o código.
        where("marketplace", "in", ["Guru Digital", "PAGARME", "IAP"])
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => {
        const data = d.data();
        return {
            productId: data.productId || d.id,
            name: data.name || data.title || data.productId || d.id,
            marketplace: data.marketplace,
            // 'plan' (assinatura) | 'product' (venda única) — usado para exibir o tipo do acesso.
            // Planos IAP não têm `type`; deduzimos pela recorrência no productId.
            type:
                data.type ||
                (data.marketplace === "IAP" &&
                    /monthly|quarterly|semiannual|yearly/i.test(data.productId || d.id)
                    ? "plan"
                    : null),
        };
    });
};

const fetchCourses = async () => {
    const snap = await getDocs(collection(firestore, "courses"));
    return snap.docs.map((d) => {
        const data = d.data();
        return {
            productId: data.productId || data.priceId || d.id,
            name: data.title || data.name || d.id,
            marketplace: "Curso",
            type: "course",
        };
    });
};

const fetchPlans = async () => {
    const snap = await getDocs(
        query(collection(firestore, "plans"), orderBy("order", "asc"))
    );

    let frequencies = [];
    const planDocs = [];
    snap.docs.forEach((d) => {
        const data = d.data();
        if (data.isPlanFrequency === true) {
            if (!frequencies.length && Array.isArray(data.planFrequency)) {
                frequencies = data.planFrequency;
            }
        } else if (data.archived !== true) {
            planDocs.push({ id: d.id, data });
        }
    });

    const items = [];
    planDocs.forEach(({ id, data }) => {
        frequencies.forEach((freq) => {
            const key = FREQUENCY_KEY_BY_ID[freq?.id];
            if (!key) return;
            const productId = data?.productIds?.[key];
            if (!productId) return;
            items.push({
                productId,
                name: `${data.title || data.name || id} | ${freq.frequency || key}`,
                marketplace: "Plano",
                type: "plan",
            });
        });
    });
    return items;
};

const dedupe = (items) => {
    const seen = new Set();
    return items.filter((it) => {
        if (!it.productId || seen.has(it.productId)) return false;
        seen.add(it.productId);
        return true;
    });
};

export const getProducts = async () => {
    const [legacy, courses, plans] = await Promise.all([
        fetchLegacyProducts(),
        fetchCourses(),
        fetchPlans(),
    ]);
    return dedupe([...legacy, ...courses, ...plans]).map((p) => ({
        ...p,
        selected: false,
    }));
};
